module.exports = __webpack_public_path__ + "img/main_jlw.e58db455.jpg";